export class ApiError extends Error {
	public statusCode: number;

	constructor(name: string, statusCode: number, message?: string) {
		super(message);
		this.name = name;
		this.statusCode = statusCode;
	}
};